import { NavBarDataInterface } from '@simOn/common/containers';

export const CALENDAR_PAGE_DATA: NavBarDataInterface = {
  headerTitle: $localize`:@@OVERLAY_MENU_CALENDAR:Calendar`,
  shortTitle: $localize`:@@OVERLAY_MENU_CALENDAR:Calendar`,
  navLinks: [],
  activeLinkIndex: 0
};
